
/**
 * 
 */
export const BOUNDARY_TYPE_MAP = {
    0: 'neighborhoods',   // NEIGHBORHOOD
    1: 'postalCities',    // POSTAL_CITY
    2: 'censusPlaces',    // CENSUS_CITY
    3: 'censusSubdivision',   // CENSUS_SUBDIVISION (无对应，fallback)
};

/**
 * Area Type Constants
 * 区域类型常量
 * 
 * 这个文件定义了所有区域类型相关的常量，用于在整个应用中保持一致性
 */

/**
 * 区域类型数字映射到类型名称
 * 用于将后端返回的 featureAreaType 数字转换为字符串类型
 */
export const NBR_TYPE_NUM = {
    0: 'city',
    1: 'subdivision',
    2: 'community',
    3: 'area',
    4: 'neighborhood',
    5: 'completeArea'
};

/**
 * 区域类型名称映射到数字
 * 用于将字符串类型转换为数字（反向映射）
 */
export const NBR_NUM_TYPE = {
    city: 0,
    subdivision: 1,
    community: 2,
    area: 3,
    neighborhood: 4,
    completeArea: 5
};

export const IS_CLICK_MAP = {
    "md-featured-area": ["layout12"],
};

export const NEED_STATS = {
    "md-featured-area": ["layout14"],
};